export interface ScorePokedex {
  statusCode: number;
  message: string;
  data: LongInventoryScorecardData;
}

export interface LongInventoryScorecardData {
  scorecardReports: ScorecardReport[];
  total: number;
}

export interface ScorecardReport {
  count: number;
  data: ScoreAggregate[] | null;
  broker: string;
  _sync_date: SyncDate;
  aggregate: ScoreAggregate[];
  tooltip: ScoreTooltip[];
  msg_id: number;
  message: Message;
}

export enum SyncDate {
  November092021At0228AmEST = 'November 09, 2021 at 02:28 am  EST',
}

export interface ScoreAggregate {
  buyer: string;
  active_listings: string;
  potential_earnings: string;
  priced_inventory: string;
  cost_priced_inventory: string;
  cost_unpriced_inventory: string;
  capital_applied: string;
  less_than_fifteen: number | null;
  fifteen_to_thirty: number | null;
  costing_issue: number | null;
  pricing_issue: number | null;
  card_missing: number | null;
}

export enum Message {
  LongInventoryScoreCardReportFetchedSuccessfully = 'Long Inventory ScoreCard Report fetched successfully.',
}

export interface ScoreTooltip {
  potential_earnings: string;
  priced_inventory: PricedInventory;
  cost_priced_inventory: string;
  cost_unpriced_inventory: CostUnpricedInventory;
  capital_applied: CapitalApplied;
  less_than_fifteen: (typeof LessThanFifteen)[keyof typeof LessThanFifteen];
  fifteen_to_thirty: (typeof FifteenToThirty)[keyof typeof FifteenToThirty];
  costing_issue: CostingIssue;
  pricing_issue: PricingIssue;
  card_missing: CardMissing;
}

export interface IQueryParams {
  alert_Id?: any;
  broker_Id?: any;
  buyer_Id?: any;
  currency_Id?: any;
}

export enum CapitalApplied {
  QuantityTicketUnitCostPrice = 'Quantity * Ticket Unit Cost Price',
}

export enum CardMissing {
  PaymentMethodIsCreditCardButDetailsAreNotAvailable = 'Payment method is Credit Card but details are not available',
}

export enum CostUnpricedInventory {
  QuantityTicketUnitCostPriceWhenListingIsEqualToZero = 'Quantity * Ticket Unit Cost Price when Listing is equal to zero',
}

export enum CostingIssue {
  TicketUnitCostIsZero = 'Ticket Unit Cost is zero',
}

const delistingThresholdVal: number = Number(
  process.env.REACT_APP_DELISTING_THRESHOLD ?? 5,
);

export const FifteenToThirty = {
  EventDateBetween15To30DaysFromToday:
    'Event Date between ' + delistingThresholdVal + ' to 30 days from today',
} as const;

export const LessThanFifteen = {
  EventDateLessThan15DaysFromToday:
    'Event Date less than ' + delistingThresholdVal + ' days from today',
} as const;

export enum PricedInventory {
  QuantityTicketUnitListingPrice = 'Quantity * Ticket Unit Listing Price',
}

export enum PricingIssue {
  TicketUnitCostIsHigherThanListPrice = 'Ticket Unit Cost is higher than List Price',
}
